import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import SignInContent from './SignInContent';

const customStyles = {
  overlay : {
    zIndex: 2000,
  },
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  }
};

class SignInModal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onForgotten: PropTypes.func.isRequired,
    isError: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    isOpen: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };
  }

  onSubmitContent = (e) => {
    e.preventDefault();
    
    const { 
      email, 
      password,
      } = this.state;
    
    this.props.onSubmit({
      email,
      password,
    });
  }

  onChangeEmail = (e) =>
    this.setState({
      email: e.target.value
    });

  onChangePassword = (e) =>
    this.setState({
      password: e.target.value
    });

  render() {
    const { 
        email,
        password,
      } = this.state;
    
    const {
        isOpen,
        onClose,
        onForgotten,
        isError,
      } = this.props;

    return (
      <Modal
        style={customStyles}
        isOpen={isOpen}
        contentLabel="Sign In"
        onRequestClose={onClose}
      >
        <SignInContent 
          onSubmit={this.onSubmitContent}
          onChangeEmail={this.onChangeEmail}
          onChangePassword={this.onChangePassword}
          onForgotten={onForgotten}
          onClose={onClose}
          email={email}
          password={password}
          isError={isError}
        />
      </Modal>
    );
  }
};

const mapStateToProps = state => ({
  isError: state.auth.isError,
})

export default connect(mapStateToProps)(SignInModal)



// WEBPACK FOOTER //
// ./src/components/SignInModal/SignInModal.jsx